import { createSelector } from 'reselect';

const selectRoute = state => state.get('router');

const makeSelectLocation = () =>
  createSelector(selectRoute, routeState => routeState.get('location').toJS());

export { makeSelectLocation };
